export default "__VITE_PUBLIC_ASSET__e34f48fe__"